module.exports = __webpack_public_path__ + "img/page12_logo.8f106fcc.png";